import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ModalImage from './ModalImage.js';
import imagesLoaded from './ImagesLoaded.js';


class MasonryGrid extends Component {
    constructor(props) {
        super(props);
        this.masonryRef = React.createRef();

        const height = props.height; //height of the container of this component
        const width = props.width; //width of the container of this component
        const images = [...props.images]; //list of images

        const imageRefList = []; //list of image dom elements
        
        const dimensions = [];
        const positions = Array.from({ length: props.images.length }, () => ({ visibility: 'hidden' }));
        
        const reorderedDimensions = [];
        const reorderedImages = [...props.images]; 

        const reorderedScaledDimensions = [];
        const scaledPositions = Array.from({ length: props.images.length }, () => ({ visibility: 'hidden' }));

        const imagesLoaded = false;

        this.state = {
            height,
            width,
            images,
            imageRefList,
            dimensions,
            positions, 
            reorderedDimensions,
            reorderedImages,
            reorderedScaledDimensions, 
            scaledPositions,
            imagesLoaded
        };
        //console.log('3. Masonry Props');
    }

    componentDidMount() {
        //console.log('5. Masonry Component Did Mount');
        if (this.props.width === 0 || this.props.height === 0 || this.masonryRef.current === null) return;
        imagesLoaded(this.masonryRef.current, (imageRefList) => {
            //console.log('5.5 inside component did mount and imagesLoaded callback');
            let masonryData = this.initializeMasonry(imageRefList);
            if (typeof this.props.onGridComplete === 'function') {
                this.props.onGridComplete(masonryData);
            }
        });
    }

    componentDidUpdate(prevProps) {
        //console.log('7. Masonry Grid Component Did Update')
        if (this.props.width === 0 || this.props.height === 0 || this.masonryRef.current === null) return;
        if (prevProps.width !== this.props.width) {
            if(!this.state.imagesLoaded){
                imagesLoaded(this.masonryRef.current, (imageRefList) => {
                //console.log('8. Inside component did update, imagesloaded - right before initialize masonry')
                this.initializeMasonry(imageRefList);
            })} else {
                this.initializeMasonry(this.state.imageRefList);
            }
        }
    }

    // Step 1: Collect the dimensions (height and width) of each item in the grid
    collectDimensions = (imageRefList, numColumns, width) => {
        const columnWidth = width / numColumns;
        const dimensions = [];

        imageRefList.forEach((image) => {
            const { naturalHeight, naturalWidth } = image;
            const aspectRatio = naturalWidth / naturalHeight;
            const itemWidth = columnWidth;
            const itemHeight = itemWidth / aspectRatio;
            dimensions.push({ dimWidth: itemWidth, dimHeight: itemHeight });
        });

        return dimensions;
    };

    // Step 2: Calculate the position of each item
    calculatePositions = (dimensions, numColumns, height, width) => {
        const positions = [];
        const columnHeights = Array(numColumns).fill(0);
        const indexArray = [];
        const columnWidth = width / numColumns;

        dimensions.forEach((dimension, index) => {
            const { dimHeight } = dimension;
            const currentColNum = index % numColumns;

            const minHeightColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));
            const shift = minHeightColumnIndex - currentColNum;
            indexArray[index] = index + shift;

            const left = columnWidth * minHeightColumnIndex;
            const top = columnHeights[minHeightColumnIndex];
            positions.push({ left, top, visibility: 'visible' });

            columnHeights[minHeightColumnIndex] += dimHeight;
        });
  
        return { positions, indexArray, columnHeights };
    };

    // Step 3: Adjust the masonry grid width to fit the longest column within the given height
    adjustGridWidth = (columnHeights, numColumns, width, height) => {
        const maxColumnHeight = Math.max(...columnHeights);
        const aspectRatio = width / maxColumnHeight;
        const maxGridWidth = aspectRatio * height;
        const scaledColumnWidth = maxGridWidth / numColumns;

        return { maxGridWidth, scaledColumnWidth };
    };

    // Step 4: Calculate the scaled width and height for each masonry cell
    calculateScaledDimensions = (dimensions, maxGridWidth, width, numColumns) => {
        const scaledDimensions = dimensions.map((dimension) => {
            const { dimHeight } = dimension;
            const scaleFactor = maxGridWidth / width;
            const scaledWidth = maxGridWidth / numColumns;
            const scaledHeight = dimHeight * scaleFactor;
            return { dimWidth: scaledWidth, dimHeight: scaledHeight };
        });

        return scaledDimensions;
    };

    // Step 5. Calculate the scaled positions for top, left of each masonry cell 
    calculateScaledPositions = (positions, scaledColumnWidth, width, numColumns) => {
        const columnWidth = width / numColumns; 
        const scaleWidthFactor = scaledColumnWidth / columnWidth;
        const scaledPositions = positions.map((position) => ({
            left: position.left * scaleWidthFactor,
            top: position.top * scaleWidthFactor,
            visibility: position.visibility,
        }));

        return scaledPositions;
    };

    // Step 6. Reorder everything based on the new index array
    reorderData = (data, indexArray) => indexArray.map((index) => data[index]);

    initializeMasonry = (imageRefList) => {
        const { numColumns, height, width } = this.props;

        // Step 1: Collect the dimensions (height and width) of each item in the grid
        const dimensions = this.collectDimensions(imageRefList, numColumns, width);
      
        // Step 2: Calculate the position of each item
        const { positions, indexArray, columnHeights } = this.calculatePositions(dimensions, numColumns, height, width);
      
        //SCALING COMMENTED FOR NOW
        // Step 3: Adjust the masonry grid width to fit the longest column within the given height
        //const { maxGridWidth, scaledColumnWidth} = this.adjustGridWidth(columnHeights, numColumns, width, height);
      
        // Step 4: Calculate the scaled width and height for each masonry cell
        //const scaledDimensions = this.calculateScaledDimensions(dimensions, maxGridWidth, width, numColumns);
      
        // Step 5. Calculate the scaled positions for top, left of each masonry cell
        //const scaledPositions = this.calculateScaledPositions(positions, scaledColumnWidth, width, numColumns);
      
        // Step 6. Reorder everything based on the new index array
        const reorderedImages = this.reorderData(imageRefList, indexArray);
        const reorderedDimensions = this.reorderData(dimensions, indexArray);
        //const reorderedScaledDimensions = this.reorderData(scaledDimensions, indexArray); 

        

        //console.log('9. right before initial masonry set state')
        const maxColumnHeight = Math.max(...columnHeights);
        const imagesLoaded = true
        this.setState({
            width, height:maxColumnHeight, 
            imageRefList, 
            positions, 
            dimensions, 
            reorderedDimensions, 
            reorderedImages, 
            imagesLoaded:imagesLoaded},() => {
                if (typeof this.props.onGridComplete === 'function') {
                    //console.log('10. Masonry Grid Done. Calling component did update masonry callback.');
                    this.props.onGridComplete(this.state);
                }
        });
    }

    render() {
        const { image_path, images, width, height } = this.props;
        const { positions, reorderedDimensions } = this.state;
        //console.log('4. Masonry Render')
        
        //This check is done on the first pass, so that the parent can get its initial height / width
        //It will then call it again with the proper values
        if (width === 0 || height === 0) return null;
        return (
            <div>
                <div className="masonry-grid" ref={this.masonryRef}>
                    {images.map((image, index) => {
                        const style = {
                            ...positions[index],
                        };
                        if (reorderedDimensions.length !== 0 ) {
                            style.width = `${reorderedDimensions[index].dimWidth}px`;
                            style.height = `${reorderedDimensions[index].dimHeight}px`;
                        }
                        return (
                            <div key={index} className="masonry-cell" style={style}>
                                <ModalImage description={image.description}>
                                    <img
                                        src={image_path + image.image}
                                        alt={`Image ${image.image}`}
                                        className="masonry-image"
                                    />
                                </ModalImage>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

MasonryGrid.defaultProps = {
    numColumns: 3,
    height: 300,
    width: 300
};

export default MasonryGrid;